import { useQuery } from "@tanstack/react-query";
import { get } from "api/api-methods";
import { useBookingId } from "hooks/use-booking-id";
import i18n from "i18next";
import { Routes } from "routes";
import { WebBooking } from "types/web-booking";

export function useWebBooking() {
    const bookingId = useBookingId() ?? "";
    const isLandingPage = location.pathname.startsWith(`/${Routes.BOOKING}/`);

    let onSuccess: ((data: WebBooking) => void) | undefined = undefined;
    if (isLandingPage) {
        onSuccess = (data: WebBooking) => {
            void i18n.changeLanguage(data.language);
        };
    }

    return useQuery({
        queryKey: ["booking", bookingId],
        queryFn: async () => {
            const response = await get<WebBooking>(`webBooking/webBookings/${bookingId}`);
            const booking = new WebBooking(response);
            if (onSuccess) {
                onSuccess(booking);
            }
            return booking;
        },
        refetchOnMount: false,
        // The query will not execute unless there's a booking ID
        enabled: !!bookingId,
    });
}
